import React, { useState, useEffect } from "react";
import Web3 from "web3";

const TokenBalance = ({ networks, walletAddress }) => {
    const [balance, setBalance] = useState(null);

    useEffect(() => {
        const fetchTokenBalance = async () => {
            try {

              //  console.log('Network data' , networks.contract_address, networks.abiData, walletAddress)
                if (!networks.contract_address || !networks.abiData || !walletAddress) return;
                

                const balancetoken = await getTokenBalance(
                    networks.contract_address,
                    JSON.parse(networks.abiData), // Fixed syntax
                    walletAddress
                );
                
                setBalance(balancetoken);
            } catch (error) {
                console.error(`Error fetching token balance for ${networks.token_contract}:`, error);
            }
        };

        fetchTokenBalance();
    }, [networks.token_contract, networks.token_abi, walletAddress]);

    return (
        <tr>
            <td> 
                <span className="avatar avatar-xm avatar-rounded">
                    <img className="rounded" src={networks.asset_logo || "N/A"} width={30} alt="Asset Logo" />
                </span>
            </td>
            <td><span>{balance !== null ? balance : "Loading..."}</span></td>
            <td><span>{networks.asset_name || "N/A"}</span></td>
            <td><span>{networks.asset_ticker || "N/A"}</span></td>
            <td><span>{networks.network || "N/A"}</span></td>
            <td><span>{networks.contract_address || "N/A"}</span></td>
            
           
        </tr>
    );
};

export default TokenBalance;

async function getTokenBalance(tokenAddress, tokenABI, publicKey) {

    try {
        const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");
        const contract = new web3.eth.Contract(tokenABI, tokenAddress);
        const balance = await contract.methods.balanceOf(publicKey).call();

        return web3.utils.fromWei(balance, "ether");
    } catch (error) {
        console.error(`Error fetching token balance for ${tokenAddress}:`, error);
        return "0";
    }
}
